export default "__VITE_ASSET__aKaeoEgo__"